export default __webpack_public_path__ + "static/media/A001.938694b3.mp3";